// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-ee7191e1] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}

/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
li.action[data-v-ee7191e1]:hover, li.action.active[data-v-ee7191e1] {
  border-radius: 6px;
  padding: 0;
}
li.action[data-v-ee7191e1]:hover {
  background-color: var(--color-background-hover);
}
.action--disabled[data-v-ee7191e1] {
  pointer-events: none;
  opacity: 0.5;
}
.action--disabled[data-v-ee7191e1]:hover, .action--disabled[data-v-ee7191e1]:focus {
  cursor: default;
  opacity: 0.5;
}
.action--disabled *[data-v-ee7191e1] {
  opacity: 1 !important;
}
.action-checkbox[data-v-ee7191e1] {
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  cursor: pointer;
  white-space: nowrap;
  color: var(--color-main-text);
  border: 0;
  border-radius: 0;
  background-color: transparent;
  box-shadow: none;
  font-weight: normal;
  line-height: var(--default-clickable-area);
  /* checkbox/radio fixes */
}
.action-checkbox__checkbox[data-v-ee7191e1] {
  position: absolute;
  inset-inline-start: 0 !important;
  z-index: -1;
  opacity: 0;
}
.action-checkbox__label[data-v-ee7191e1] {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 !important;
  padding-inline-end: calc((var(--default-clickable-area) - 16px) / 2) !important;
}
.action-checkbox__label[data-v-ee7191e1]::before {
  margin-block: 0 !important;
  margin-inline: calc((var(--default-clickable-area) - 14px) / 2) !important;
}
.action-checkbox--disabled[data-v-ee7191e1],
.action-checkbox--disabled .action-checkbox__label[data-v-ee7191e1] {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcActionCheckbox-DvdNISIs.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE;AACF;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,+CAA+C;AACjD;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,+EAA+E;AACjF;AACA;EACE,0BAA0B;EAC1B,0EAA0E;AAC5E;AACA;;EAEE,eAAe;AACjB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-ee7191e1] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n\n/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\nli.action[data-v-ee7191e1]:hover, li.action.active[data-v-ee7191e1] {\n  border-radius: 6px;\n  padding: 0;\n}\nli.action[data-v-ee7191e1]:hover {\n  background-color: var(--color-background-hover);\n}\n.action--disabled[data-v-ee7191e1] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.action--disabled[data-v-ee7191e1]:hover, .action--disabled[data-v-ee7191e1]:focus {\n  cursor: default;\n  opacity: 0.5;\n}\n.action--disabled *[data-v-ee7191e1] {\n  opacity: 1 !important;\n}\n.action-checkbox[data-v-ee7191e1] {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  white-space: nowrap;\n  color: var(--color-main-text);\n  border: 0;\n  border-radius: 0;\n  background-color: transparent;\n  box-shadow: none;\n  font-weight: normal;\n  line-height: var(--default-clickable-area);\n  /* checkbox/radio fixes */\n}\n.action-checkbox__checkbox[data-v-ee7191e1] {\n  position: absolute;\n  inset-inline-start: 0 !important;\n  z-index: -1;\n  opacity: 0;\n}\n.action-checkbox__label[data-v-ee7191e1] {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0 !important;\n  padding-inline-end: calc((var(--default-clickable-area) - 16px) / 2) !important;\n}\n.action-checkbox__label[data-v-ee7191e1]::before {\n  margin-block: 0 !important;\n  margin-inline: calc((var(--default-clickable-area) - 14px) / 2) !important;\n}\n.action-checkbox--disabled[data-v-ee7191e1],\n.action-checkbox--disabled .action-checkbox__label[data-v-ee7191e1] {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
